import { useState } from 'react';

import { Container } from '@/atoms';
import { CardProduct, Modal } from '@/molecules';

import type { FunctionComponent } from 'react';

/**
 * CardProductWordpress
 */
export const CardVideo: FunctionComponent<any> = ({
  card,
  className = '',
}: {
  card: any;
  className: string;
}) => {
  const [openModal, setOpenModal]: any = useState(false);
  return (
    <Container
      className={`h-full overflow-hidden outline outline-1 outline-primary-200 ${className}`}
      backgroundColor="bg-bg-secondary"
      padding="p-0"
      justify="justify-start"
      align="items-start"
    >
      <div className="relative flex w-full flex-col">
        <div
          className="relative m-2 h-[166px] w-[calc(100%_-_(2_*_8px))] cursor-pointer overflow-hidden"
          onClick={() => {
            setOpenModal(true);
          }}
        >
          <CardProduct.Image
            src={card.imagenPreview.sourceUrl}
            alt={card.imagenPreview.sourceUrl.altText}
            {...(card.imageBackgroundColor
              ? { backgroundColor: card.imageBackgroundColor }
              : {})}
          />
        </div>
        <h3 className="u-headline u-headline--h3 mx-2 mb-4">{card.titulo}</h3>
        <p className="u-body u-body--s mx-2 mb-6 text-primary-700">
          {card.description}
        </p>
      </div>

      <Modal open={openModal} setOpen={setOpenModal} noMaxWidthDesktop={true}>
        <h3 className="u-headline u-headline--h3 mb-4">{card.titulo}</h3>
        <iframe
          src={`https://player.vimeo.com/video/${card.idvideo}?autoplay=1&loop=1&autopause=0`}
          width="640"
          height="360"
          frameBorder="0"
          allow="autoplay; fullscreen"
          allowFullScreen
        />
      </Modal>
    </Container>
  );
};

CardVideo.displayName = 'CardProductWordpress';
